import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { getUser } from '~features/user/ducks';

const useUserOfficeAsDefault = ({ change }) => {
  const user = useSelector(state => getUser(state));
  // These are fetched on app initialization
  const offices = useSelector(state => state.reducer.offices);
  const userOfficeId = user?.ordererOrganization.officeId;

  useEffect(() => {
    if (!userOfficeId || offices?.length === 0) return;

    const office = offices.find(office => office.id === userOfficeId);

    if (office) {
      // If the user office is found, set it as the default _by id_
      change(office.id);
    }
  }, [offices, userOfficeId]);
};

export default useUserOfficeAsDefault;
